import React from "react";
import { useFormikContext } from "formik";
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
} from "@material-tailwind/react";

export default function DeleteCustomAnswerDialog({
    showDialog,
    handleClose,
    setShowDialog,
    setReallyDeleteCustom,
    question,
    questionPresets,
}) {
    const { setFieldValue, submitForm } = useFormikContext();

    const handleConfirmCustomDelete = () => {
        setReallyDeleteCustom(true);
        setShowDialog(false);
        submitForm();
    };

    const handleDenyCustomDelete = () => {
        if (question.answer_type === "single") {
            setFieldValue(
                "answer",
                new Array(questionPresets.preset_answers.length),
            );
        }
        setShowDialog(false);
        submitForm();
    };

    return (
        <Dialog
            open={showDialog}
            handler={handleClose}
            className="dialog"
            size="lg"
            animate={{
                mount: { scale: 1, y: 0 },
                unmount: { scale: 1, y: -100 },
            }}
        >
            <DialogHeader className="dialog__header">
                Are you sure you wish to remove your typed response?
            </DialogHeader>
            <DialogBody className="dialog__body">
                Choosing this option will remove your typed response, did you
                really want to do that?
            </DialogBody>
            <DialogFooter className="dialog__footer">
                <div className="bottom-2">
                    <Button
                        type="button"
                        className="btn btn--secondary"
                        variant="outlined"
                        onClick={() => handleDenyCustomDelete()}
                    >
                        No, keep my response
                    </Button>
                </div>
                <div className="bottom-2">
                    <Button
                        type="button"
                        className="btn btn--primary"
                        variant="filled"
                        onClick={() => handleConfirmCustomDelete()}
                    >
                        Yes, change my response
                    </Button>
                </div>
            </DialogFooter>
        </Dialog>
    );
}
